import { RPCDocs } from "../../../services/rpc.js";
import { LocationName } from "../../Locations/shared/LocationName.js";
import "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Users/shared/UserGeoRelativeLocationLabel.tsx
function UserGeoRelativeLocationLabel({ relativeLocation }) {
	return relativeLocation && /* @__PURE__ */ jsxs(Fragment$1, { children: [
		relativeLocation.status === RPCDocs.ActivityFeed.GetOpsActivityFeed.v1.Status.Near ? "Near" : "Inside Geo-Fence",
		" ",
		/* @__PURE__ */ jsx(LocationName, { locationId: relativeLocation.locationId })
	] });
}
//#endregion
export { UserGeoRelativeLocationLabel };

//# sourceMappingURL=UserGeoRelativeLocationLabel.js.map